export const productCartSelectorEvents = {
  SELECT_ADD_PRODUCT: "web_select_add_product",
};
